// product details page review section loader set js
window.onload = function () {
  // Function to check and show/hide the review button and form
  var sectionContainer = document.querySelector(
    ".kaktusc-container"
  );

  // Create loader element
  var loader = document.createElement("div");
  loader.className = "loader"; // You can style this class in your CSS for the loader appearance

  loader.className = "row justify-content-center add-margin";

  // Set loader content to an image or use background image
  loader.innerHTML =
    '<i class="fa fa-circle-o-notch fa-spin fa-fw" style="font-size: 40px;color: #513030;"></i>';

  // Append loader to the section container
  sectionContainer.appendChild(loader);
  // productsectionContainer.appendChild(loader);

  function checkAndToggleReviewsload() {
    var checktestimonialapp = document.querySelector(".kaktus-w-product__wrapp");

    if (checktestimonialapp) {
      // The target element is present, hide the loader
      loader.style.display = "none";
    }
  }

  // Check initially
  checkAndToggleReviewsload();

  // Use MutationObserver to watch for changes in the DOM
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      // Check again whenever the DOM changes
      checkAndToggleReviewsload();
    });
  });

  // Configure and start the observer
  var observerConfig = {
    childList: true, // Watch for changes in the child elements
    subtree: true, // Watch for changes in the whole subtree
  };

  observer.observe(document.body, observerConfig);
};



// Code for product url in wishlist

  // document.addEventListener('DOMContentLoaded', function() {
  //   // Function to handle the click event
  //   function handleClick(event) {
  //     var productItem = event.target.closest('.kaktus-w-product__item');
  //     if (productItem) {
  //       var productTitle = productItem.querySelector('.kaktus-w-product__title').innerText;
  //       var productDetailURL = 'https://www.mypetcarnivore.com/products/' + encodeURIComponent(productTitle.toLowerCase().replace(/[^a-zA-Z0-9]/g, '-'));
  //       window.location.href = productDetailURL;
  //     }
  //   }

  //   // Function to attach click event listeners to all product cards
  //   function attachClickEventListeners() {
  //     var productItems = document.querySelectorAll('.kaktus-w-product__item');
  //     productItems.forEach(function(item) {
  //       item.addEventListener('click', handleClick);
  //     });
  //   }

  //   // Initial attachment of click event listeners
  //   attachClickEventListeners();

  //   // Create a MutationObserver to observe changes in the DOM
  //   var observer = new MutationObserver(function(mutationsList) {
  //     mutationsList.forEach(function(mutation) {
  //       if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
  //         // Check if any new product cards have been added
  //         attachClickEventListeners();
  //       }
  //     });
  //   });

  //   // Start observing changes in the DOM
  //   observer.observe(document.body, { childList: true, subtree: true });
  // });




 // updated code for product url in wishlist by removing last dot "."

document.addEventListener('DOMContentLoaded', function() {
    // Function to handle the click event
    function handleClick(event) {
        var productItem = event.target.closest('.kaktus-w-product__item');
        var isButton = event.target.closest('.kaktus-w-product__actions');
        
        // Check if the clicked element is within a product item and is not a button
        if (productItem && !isButton) {
            var productTitle = productItem.querySelector('.kaktus-w-product__title').innerText.trim();
            
            // Remove the last dot from the product title
            productTitle = productTitle.replace(/\.$/, ''); // Removes the last dot if it exists
            
            var productDetailURL = 'https://www.mypetcarnivore.com/products/' + encodeURIComponent(productTitle.toLowerCase().replace(/[^a-zA-Z0-9]/g, '-'));
            window.location.href = productDetailURL;
        }
    }

    // Function to attach click event listeners to all product cards
    function attachClickEventListeners() {
        var productItems = document.querySelectorAll('.kaktus-w-product__item');
        productItems.forEach(function(item) {
            item.addEventListener('click', handleClick);
        });
    }

    // Initial attachment of click event listeners
    attachClickEventListeners();

    // Create a MutationObserver to observe changes in the DOM
    var observer = new MutationObserver(function(mutationsList) {
        mutationsList.forEach(function(mutation) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                // Check if any new product cards have been added
                attachClickEventListeners();
            }
        });
    });

    // Start observing changes in the DOM
    observer.observe(document.body, { childList: true, subtree: true });
});









